var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-wrapper", class: _vm.theme },
    [
      _vm.showAd
        ? _c("span", { staticClass: "action" }, [
            _vm.theme === "light"
              ? _c(
                  "a",
                  {
                    staticClass: "ad_title",
                    attrs: { target: "_blank", href: _vm.payFeeUrl },
                  },
                  [
                    _c("a-icon", {
                      staticStyle: {
                        color: "yellow",
                        "font-size": "16px",
                        "line-height": "16px",
                        "padding-right": "5px",
                      },
                      attrs: { type: "cloud", theme: "filled" },
                    }),
                    _c("span", [_vm._v("忙果ERP网络版198元1年")]),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        "span",
        { staticClass: "action", on: { click: _vm.showClick } },
        [_c("a-icon", { attrs: { type: "search" } })],
        1
      ),
      _c(
        _vm.searchMenuComp,
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.searchMenuVisible || _vm.isMobile(),
              expression: "searchMenuVisible || isMobile()",
            },
          ],
          tag: "component",
          staticClass: "borders",
          attrs: {
            visible: _vm.searchMenuVisible,
            title: "搜索菜单",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.searchMenuVisible = false
            },
          },
        },
        [
          _c(
            "a-select",
            {
              staticClass: "search-input",
              style: _vm.isMobile()
                ? { width: "100%", marginBottom: "50px" }
                : {},
              attrs: {
                showSearch: "",
                showArrow: false,
                placeholder: "搜索菜单",
                optionFilterProp: "children",
                filterOption: _vm.filterOption,
                open: _vm.isMobile() ? true : null,
                getPopupContainer: (node) => node.parentNode,
              },
              on: { change: _vm.searchMethods, blur: _vm.hiddenClick },
            },
            _vm._l(_vm.searchMenuOptions, function (site, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: site.id } },
                [_vm._v(_vm._s(site.text))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "action" },
        [
          _c(
            "a-tooltip",
            [
              _c("template", { slot: "title" }, [_vm._v("官方网站")]),
              _c(
                "a",
                { attrs: { target: "_blank", href: _vm.systemUrl } },
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "16px" },
                    attrs: { type: "bank" },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("header-notice", { staticClass: "action" }),
      _vm.isDesktop()
        ? _c(
            "a-dropdown",
            [
              _c(
                "span",
                { staticClass: "action ant-dropdown-link user-dropdown-menu" },
                [
                  _c("a-icon", { attrs: { type: "down-circle" } }),
                  _c("span", { staticStyle: { "margin-left": "4px" } }, [
                    _vm._v("欢迎您，" + _vm._s(_vm.nickname())),
                  ]),
                ],
                1
              ),
              _c(
                "a-menu",
                {
                  staticClass: "user-dropdown-menu-wrapper",
                  attrs: { slot: "overlay" },
                  slot: "overlay",
                },
                [
                  _c(
                    "a-menu-item",
                    { key: "3", on: { click: _vm.systemSetting } },
                    [
                      _c("a-icon", { attrs: { type: "tool" } }),
                      _c("span", [_vm._v("界面设置")]),
                    ],
                    1
                  ),
                  _c(
                    "a-menu-item",
                    { key: "4", on: { click: _vm.updatePassword } },
                    [
                      _c("a-icon", { attrs: { type: "setting" } }),
                      _c("span", [_vm._v("密码修改")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("span", { staticClass: "action" }, [
        _c(
          "a",
          {
            staticClass: "logout_title",
            attrs: { href: "javascript:;" },
            on: { click: _vm.handleLogout },
          },
          [
            _c("a-icon", { attrs: { type: "logout" } }),
            _c("span", [_vm._v(" 退出登录")]),
          ],
          1
        ),
      ]),
      _c("user-password", { ref: "userPassword" }),
      _c("depart-select", {
        ref: "departSelect",
        attrs: { closable: true, title: "部门切换" },
      }),
      _c("setting-drawer", {
        ref: "settingDrawer",
        attrs: { closable: true, title: "系统设置" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }